export const theme = {
  yellow: "#fac83c",
};
